import React, {ReactNode} from 'react';
import {Button, Drawer, Dropdown, Menu} from 'antd';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars} from "@fortawesome/free-solid-svg-icons";
import {Flex} from '../components/styled/Flex';
//import {DownOutlined} from '@ant-design/icons';
import logo from './logo.svg';
import {getUserFromToken} from '../context/AuthContext';
import {Text} from '../components/styled/Text';
import {useHistory, useLocation} from "react-router";
import {Link} from "react-router-dom";
import {HorizontalLayout} from "./HorizontalLayout";
import {LMediaQuery, MMediaQuery, SMediaQuery, XLMediaQuery, XSMediaQuery} from "../components/mediaquery";
import {createCanBoundTo} from "@casl/react";
import {PermissionContext} from "../context/PermissionContext";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {LogoutOutlined} from '@ant-design/icons';
import {faUserCircle} from "@fortawesome/free-regular-svg-icons";
import {ROOT_REDIRECT, SETUP_REDIRECT, USER_REDIRECT} from "../components/ReservedSwitcher";
import {ConfigContext} from "../context/ConfigurationContext";
import {useKeycloak} from "@react-keycloak/web";
import { DownOutlined } from '@ant-design/icons';
//import logo from './sergen-logo7.png';


export const MAIN_COLOR = '#d40000';

export interface HeaderProps {
    style?: React.CSSProperties;
}

type HeaderType =  HeaderProps;

//const initialState =  'it';

const mainURL = window.location.origin;

const isSetup = (path: string): boolean => {
  return  path === SETUP_REDIRECT;
};


const Header:React.FC<HeaderType> = (props) => {

    const location = useLocation();
    //const [showMenu, setShowMenu] = React.useState(false);
    const permissionManager = React.useContext(PermissionContext);
    const history = useHistory();
    //const auth = React.useContext(AuthContext);
    const {keycloak, initialized} = useKeycloak();

    const {pathname} = history.location;

    const conf = React.useContext(ConfigContext);

    const Can = createCanBoundTo(permissionManager.ability);

    const [visibleMenu, setVisibleMenu] = React.useState(false)

    const closeMenuHandler = () => {
        setVisibleMenu(false);
    };


    const renderMenuItem =
        (path: string, label: string, match: string, colorMenu: string, rendered?: boolean) => {

            const {pathname, search} = location;

            const selected = (pathname+search === match);

            const render = rendered ?? true;

            const item = (render ?
                    <Link
                        to={path}
                        style={{
                            color: colorMenu
                        }}
                    >
                        <span>{label}</span>
                    </Link> :
                    <span>{label}</span>
            );

            return (
                <Text
                    padding={'10px'}
                    color={(render ? colorMenu : 'lightgray')}
                    className={'noprint'}
                    fontWeight={((render && selected) ? '700' : '200')}
                    style={{cursor: (render ? 'pointer' : 'not-allowed')}}
                >
                    {item}

                </Text>
            );
        };



    const menu = (
        <Menu>

            <Menu.Item >
                {renderMenuItem(`${USER_REDIRECT}?action=user-update`, 'Modifica Anagrafica', `${USER_REDIRECT}?action=user-update`, '#686868')}

            </Menu.Item>
            <Menu.Item >

                {renderMenuItem(`${USER_REDIRECT}?action=policy-update`, 'Modifica Consensi', `${USER_REDIRECT}?action=policy-update`, '#686868')}

            </Menu.Item>
            <Menu.Item >

                {renderMenuItem(`${USER_REDIRECT}?action=email-update`, 'Modifica Email', `${USER_REDIRECT}?action=email-update`, '#686868')}

            </Menu.Item>
        </Menu>
    );



    const getMenuSmall = () => {
        return (
            <>
            <div onClick={()=> {setVisibleMenu(!visibleMenu)}}>
                {!visibleMenu && <FontAwesomeIcon className={'noprint'} icon={faBars} style={{fontSize: '2rem', color: MAIN_COLOR}}/>}
                {visibleMenu &&  <FontAwesomeIcon className={'noprint'}  icon={faTimes} style={{fontSize: '2rem', color: MAIN_COLOR}}/>}

            </div>
            <Drawer
                placement="left"
                closable={true}
                onClose={closeMenuHandler}
                visible={visibleMenu}
            >
                <Flex direction={'column'} justify={'flex-start'} align={'flex-start'}>
                    {logoInfo(true)}

                    {!isSetup(pathname) &&
                        <>
                    <Can do={'View'} on={'Anagrafica'}>
                        {renderMenuItem(`${USER_REDIRECT}`, 'Anagrafica', `${USER_REDIRECT}`, '#686868')}

                        {renderMenuItem(`${USER_REDIRECT}?action=user-update`, 'Modifica Anagrafica', `${USER_REDIRECT}?action=user-update`, '#686868')}


                        {renderMenuItem(`${USER_REDIRECT}?action=email-update`, 'Modifica Email', `${USER_REDIRECT}?action=email-update`, '#686868')}


                        {renderMenuItem(`${USER_REDIRECT}?action=policy-update`, 'Modifica Consensi', `${USER_REDIRECT}?action=policy-update`, '#686868')}

                    </Can>
                    <Can do={'View'} on={'Referto'}>
                        {renderMenuItem(`${USER_REDIRECT}?action=view-results`, 'Risultati Test', `${USER_REDIRECT}?action=view-results`, '#686868')}
                    </Can>
                    <Can do={'View'} on={'Anagrafica'}>
                        {renderMenuItem(`${USER_REDIRECT}?action=goto-survey`, 'Questionario', `${USER_REDIRECT}?action=goto-survey`, '#686868')}
                    </Can>

                        {keycloak.authenticated &&
                        <Text className={'noprint'} style={{textAlign: 'center'}}>


                            {getUserFromToken(keycloak)}

                            <Button
                                style={{marginTop: '20px'}}
                                color={'#a6a6a6'}
                                shape="circle"
                                size={'large'}
                                type={'primary'}
                                icon={<LogoutOutlined/>}
                                onClick={() => {

                                    if (keycloak.authenticated && keycloak.token !== undefined) {
                                        keycloak.logout({redirectUri: `${mainURL}${ROOT_REDIRECT}`});
                                    }
                                }}
                            />
                        </Text>

                        }
                        </>
                    }

                </Flex>
            </Drawer>
            </>
        )
    };



    const logoInfo = (inner?: boolean) => {
        const size: [string, string] = (inner? ['1rem', '0.6rem']: ['2rem', '1.2rem']);

        return (
            <Flex direction={'row'}>
                <Text padding={'10px'} paddingLeft={'20px'}>
                    <a href={conf['rootPath']}>
                        <img className={'logo'} style={{height: '80px', width: 'auto'}} alt={'SerGenCovid19'} src={logo} />
                    </a>
                </Text>
            </Flex>
        )
    }

//${conf['surveyPath']}
    const xtraLargeDisplayHeader = () => {
        return (

            <Flex
                className="header-xl"
                style={props.style}
                direction="row" align='space-between' justify='space-between'>
                <HorizontalLayout>
                    {logoInfo()}
                    {!isSetup(pathname) &&
                        <>
                    <Can do={'View'} on={'Anagrafica'}>

                        {renderMenuItem(`${USER_REDIRECT}`, 'Anagrafica', `${USER_REDIRECT}`, '#686868')}   

                        <Dropdown overlay={menu}>
                            <div>
                                <span style={{color: '#686868'}}>Modifica </span>
                                <DownOutlined color={'#686868'}/>
                            </div>
                        </Dropdown>
                    </Can>
                    <Can do={'View'} on={'Referto'}>
                        {renderMenuItem(`${USER_REDIRECT}?action=view-results`, 'Risultati Test', `${USER_REDIRECT}?action=view-results`, '#686868')}
                    </Can>
                    <Can do={'View'} on={'Anagrafica'}>
                        {renderMenuItem(`${USER_REDIRECT}?action=goto-survey`, 'Questionario', `${USER_REDIRECT}?action=goto-survey`, '#686868')}
                    </Can>
                    {keycloak.authenticated &&
                    <Flex className={'noprint'} direction={'row'}>

                        <Text
                            padding={'5px'}
                            paddingRight={'8px'}
                            borderRadius={'20px'}
                            border={`1px solid #dedede`}
                            marginRight={'10px'}
                        >

                            <FontAwesomeIcon
                                color={'#a6a6a6'}
                                icon={faUserCircle}
                                style={{marginRight: '5px'}}
                            />
                            {getUserFromToken(keycloak)}
                        </Text>
                        <Button
                            style={{marginRight: '20px'}}
                            color={'#a6a6a6'}
                            shape="circle"
                            icon={<LogoutOutlined/>}
                            onClick={() => {

                                if (keycloak.authenticated && keycloak.token !== undefined) {
                                    keycloak.logout({redirectUri: `${mainURL}${ROOT_REDIRECT}`});
                                }
                            }}
                        />

                    </Flex>

                    }
                        </>
                    }
                </HorizontalLayout>
            </Flex>


        )
    };



    const smallDisplayHeader = () => {
        return (

            <Flex
                className="header-xl"
                style={props.style}
                direction="row" align='center' justify='space-between'>

                {logoInfo()}


                <Text marginRight={'10px'}>
                    {getMenuSmall()}
                </Text>

            </Flex>


        )
    };




    return (
        <header style={{width: '100%'}}>
            <XLMediaQuery>
                {xtraLargeDisplayHeader()}
            </XLMediaQuery>
            <LMediaQuery>
                {smallDisplayHeader()}
            </LMediaQuery>
            <MMediaQuery>
                {smallDisplayHeader()}
            </MMediaQuery>
            <XSMediaQuery>
                {smallDisplayHeader()}
            </XSMediaQuery>
            <SMediaQuery>
                {smallDisplayHeader()}
            </SMediaQuery>
        </header>
    )

};
export default Header;